import { MessagesWithAds, UserData } from '../chat'
import PdfForm from '../PdfForm'
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog'

interface PdfModalProps {
  isOpen: boolean
  onClose: () => void
  userData: UserData | null
  setOpenPdfModal: (open: boolean) => void
  setMessagesWithAds: React.Dispatch<React.SetStateAction<MessagesWithAds[]>>
}

const PdfModal = ({
  isOpen,
  onClose,
  setOpenPdfModal,
  setMessagesWithAds,
}: PdfModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        onInteractOutside={e => e.preventDefault()}
        className='rounded-xl p-5 py-9 md:p-9 bg-white shadow-lg w-[calc(100%-32px)] h-full max-w-[600px] max-h-[650px] overflow-y-auto hide-scroll
  [&_>button]:w-6 [&_>button]:h-6 [&_>button]:top-1 sm:[&_>button]:top-2 [&_>button]:right-1 sm:[&_>button]:right-2 [&_>button]:flex [&_>button]:justify-center [&_>button]:items-center'
      >
        <DialogTitle className='pb-4 text-black font-semibold text-lg md:text-2xl'>
          Generate The Estimation
        </DialogTitle>
        <PdfForm
          setOpenPdfModal={setOpenPdfModal}
          setMessagesWithAds={setMessagesWithAds}
        />
      </DialogContent>
    </Dialog>
  )
}

export default PdfModal
